export const ownCompanyCusId = 202

export const IsOwnTukNm = "ใช้รถ LIT"

export const shippingDocColNm = {
  Doc1Tm: "เวลาเอกสาร 1",
  Doc2Tm: "เวลาเอกสาร 2",
}

export const childAbbr = "LIT"